import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter,RouterProvider} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {configureApi,FeedbackBoundary} from '@rolling-ranch/ui';
import '@rolling-ranch/ui/styles.css';
import './styles.css';
import './refinements.css';
import './theme.css';
import './prototype.css';
import './design-match.css';
import './shell-parity.css';
import {App} from './App';
import {RouteFailure} from './RouteFailure';
document.documentElement.dataset.theme='light';
try{localStorage.removeItem('rolling-ranch.theme');}catch{/* The workspace also works when browser storage is unavailable. */}
configureApi({});
const queryClient=new QueryClient({defaultOptions:{queries:{retry:1,refetchOnWindowFocus:true,staleTime:15_000},mutations:{retry:false}}});
const router=createBrowserRouter([{path:'*',element:<App/>,errorElement:<RouteFailure/>}]);
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><QueryClientProvider client={queryClient}><FeedbackBoundary><RouterProvider router={router}/></FeedbackBoundary></QueryClientProvider></React.StrictMode>);

import './print.css';
import './list-design-system.css';
